
import React from 'react';

const MobileStickyCall: React.FC = () => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-4 bg-white/80 dark:bg-background-dark/80 backdrop-blur-lg border-t border-gray-100 dark:border-gray-800 shadow-[0_-10px_25px_-5px_rgba(0,0,0,0.1)]">
      <div className="max-w-md mx-auto">
        <a 
          href="tel:5551234567" 
          className="flex items-center justify-center gap-3 w-full bg-primary text-white py-4 rounded-2xl font-black text-lg shadow-xl shadow-primary/30 active:scale-95 transition-transform uppercase tracking-tight"
        >
          Click Here to Call
        </a>
      </div>
      <div className="h-[env(safe-area-inset-bottom)]"></div>
    </div>
  );
};

export default MobileStickyCall;
